import { useSelector } from 'src/store';
import { selectors } from 'src/store/search';

export const useSearchQueryState = () => useSelector(selectors.selectSearchQuery);
